<sim-basic-material-dialog
	(closeClicked)="close({action: 'close'})"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<div dialogContent>
		<div class="sessionStartInfo">
			{{ T.DURATION_DIALOG_SESSION_START | translate }}
			<b> {{ data?.startTime | date: (T.DATE_FORMAT_TIME | translate) : "" : translate.currentLang }} </b>.
			{{ T.DURATION_DIALOG_SESSION_DURATION | translate }}
		</div>

		<div class="durationDisplay" [formGroup]="duration">
			<div class="hours">
				<input [placeholder]="duration.controls.min.value ? '00' : 'HH'" class="timeInput" formControlName="hour" type="number" />
				@if (duration.controls?.hour?.errors?.min || duration.controls?.hour?.errors?.max) {
					<div class="error">
						{{ T.DURATION_DIALOG_HOUR_ERROR | translate }}
					</div>
				}
			</div>

			<div class="divider">:</div>

			<div class="minutes">
				<input [placeholder]="duration.controls.hour.value ? '00' : 'MM'" class="timeInput" formControlName="min" type="number" />
				@if (duration.controls?.min?.errors?.min || duration.controls?.min?.errors?.max) {
					<div class="error">
						{{ T.DURATION_DIALOG_MINUTE_ERROR | translate }}
					</div>
				}
			</div>
		</div>

		<mat-divider style="margin-top: 15px; margin-bottom: 15px" />

		<div class="durationSuggestions">
			<div class="durationSuggestionsTitle">
				{{ T.DURATION_DIALOG_SESSION_SUGGESTIONS | translate }}
			</div>

			<div class="suggestions">
				<mat-chip-listbox hideSingleSelectionIndicator>
					@for (suggestion of suggestions; track suggestion) {
						<mat-chip-option (click)="setDuration(suggestion)" [selectable]="false" color="accent" highlighted selected>
							{{ suggestion.hour | addLeadingZero }} :
							{{ suggestion.min | addLeadingZero }}
						</mat-chip-option>
					}
				</mat-chip-listbox>
			</div>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[color]="'warn'"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
		/>

		<sim-button
			[disabled]="!duration.valid"
			(onClick)="ok()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
